import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Phone } from "lucide-react";

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer data-testid="footer" className="border-t border-white/8 py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-[1.5fr_1fr_1fr] gap-12">
          <div>
            <p className="font-display font-semibold text-2xl tracking-tight text-white">
              Wadöo<span className="text-mint">.</span>
            </p>
            <p className="mt-4 text-sm text-white/50 max-w-xs leading-relaxed">{t("footer.tagline")}</p>
            <p className="mt-6 text-xs text-white/30">{t("footer.madeIn")}</p>
            <a href="tel:+33159580342" data-testid="footer-phone" className="mt-3 inline-flex items-center gap-2 text-xs text-white/40 hover:text-mint transition-colors duration-200">
              <Phone className="w-3.5 h-3.5" strokeWidth={1.5} />
              +33 1 59 58 03 42
            </a>
          </div>
          <div>
            <p className="text-xs font-medium uppercase tracking-[0.2em] text-white/40 mb-5">{t("footer.productTitle")}</p>
            <ul className="space-y-3">
              <li><a href="/#product" data-testid="footer-link-product" className="text-sm text-white/60 hover:text-white transition-colors duration-200">{t("nav.product")}</a></li>
              <li><a href="/#pricing" data-testid="footer-link-pricing" className="text-sm text-white/60 hover:text-white transition-colors duration-200">{t("nav.pricing")}</a></li>
              <li><a href="/#security" data-testid="footer-link-security" className="text-sm text-white/60 hover:text-white transition-colors duration-200">{t("nav.security")}</a></li>
              <li><Link to="/blog" data-testid="footer-link-blog" className="text-sm text-white/60 hover:text-white transition-colors duration-200">{t("nav.blog")}</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-medium uppercase tracking-[0.2em] text-white/40 mb-5">{t("footer.legalTitle")}</p>
            <ul className="space-y-3">
              <li><Link to="/legal/mentions" data-testid="footer-link-mentions" className="text-sm text-white/60 hover:text-white transition-colors duration-200">{t("footer.legal.mentions")}</Link></li>
              <li><Link to="/legal/cgv" data-testid="footer-link-cgv" className="text-sm text-white/60 hover:text-white transition-colors duration-200">{t("footer.legal.cgv")}</Link></li>
              <li><Link to="/legal/privacy" data-testid="footer-link-privacy" className="text-sm text-white/60 hover:text-white transition-colors duration-200">{t("footer.legal.privacy")}</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-white/5">
          <p data-testid="footer-copyright" className="text-xs text-white/30">{t("footer.copyright")}</p>
        </div>
      </div>
    </footer>
  );
};
